export const MenuList = [
    //Dashboard
    {
        title: 'Dashboard',	
        classsChange: 'mm-collapse',	
        iconStyle: <i className="flaticon-381-networking"></i>,
        to: '/dashboard',
    },

    {
        title: 'Bank Accounts',	
        iconStyle: <i className="flaticon-381-briefcase"></i>,
        classsChange: 'mm-collapse',
        content: [
            {
                title: 'Add Bank Account',
                to: '/merchants-bank-accounts/create'
            },
            {
                title: 'Manage Bank Accounts',
                to: '/merchants-bank-accounts'
            },
        ]
    },

    {
        title: 'KYC',	
        iconStyle: <i className="flaticon-381-file"></i>,
        to: '/merchants-kyc',
    },

    {
        title: 'Whitelist IP',	
        iconStyle: <i className="flaticon-381-padlock-2"></i>,
        classsChange: 'mm-collapse',
        content: [
            {
                title: 'Add Server IP',
                to: '/ip-whitelisted/create'
            },
            {
                title: 'Manage Server IP',
                to: '/ip-whitelisted'
            },
        ]
    },

    {
        title: 'Fund Requests',	
        iconStyle: <i className="flaticon-381-id-card"></i>,
        classsChange: 'mm-collapse',
        content: [
            {
                title: 'Create Fund Requests',
                to: '/fund-requests/create'
            },
            {
                title: 'Manage Fund Requests',
                to: '/fund-requests'
            },
        ]
    },

    {
        title: 'Single Transfer',	
        iconStyle: <i className="flaticon-381-diploma"></i>,
        classsChange: 'mm-collapse',
        content: [
            {
                title: 'Add Single Transfer',
                to: '/fund-transfer/single'
            },
            {
                title: 'Manage Transactions',
                to: '/manage-transactions'
            },
        ]
    },


    {
        title: 'Bulk Transfer',	
        iconStyle: <i className="flaticon-381-folder"></i>,
        classsChange: 'mm-collapse',
        content: [
            {
                title: 'Add Bulk Transfer',
                to: '/bulk-fund-transfer/create'
            },
            {
                title: 'Manage Transactions',
                to: '/bulk-fund-transfer'
            },
        ]
    },

    
    {
        title: 'Transactions',	
        iconStyle: <i className="flaticon-381-list"></i>,
        to: '/transactions',
    },
    {
        title: 'Reports',	
        iconStyle: <i className="flaticon-381-network"></i>,
        classsChange: 'mm-collapse',
        content: [
            {
                title: 'Fund Requests',
                to: '/reports/fund-requests'
            },
            {
                title: 'Payouts',
                to: '/reports/payout'
            },
            {
                title: 'Daily Report',
                to: '/reports/summary'
            },
        ]
    },
    {
        title: 'Documentation',	
        iconStyle: <i className="flaticon-381-file-1"></i>,
        to: '/documentation',
    },
]